import axios from '@axios'

export default {
  namespaced: true,
  state: {
    grupos: [],
  },
  getters: {
    GET_GROUPS: state => {
        return state.grupos
    },
  },
  mutations: {
    SET_GRUPOS(state, payload) {
      state.grupos = payload
    },
  },
  actions: {
    FIND_GROUPS({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/groups')
          .then(response => {
            commit('SET_GRUPOS', response.data.grupos)
            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
  },
}
